import { ArrowLeft, MoveRight } from "lucide-react";
import { ChangeEvent, useEffect, useState } from 'react';
import { cn } from "utils/cn";
import Button from "../Button";
import { Input } from "../Input";
import Label from "../Label";
import ResponsiveDialog from "../ResponsiveDialog";


export type LoginModalProps = {
    handleChangeLoginEmail: (event: ChangeEvent<HTMLInputElement>) => void;
    isLoadingForgot: boolean;
    email: string;
    forgotPassword: () => void;
    handleGotoLogin: () => void;
    bannerMessage?: string
    bannerMessageIsError?: boolean,
    container?: HTMLElement | ShadowRoot | null;
};

export default function ForgetPasswordModal({
    handleChangeLoginEmail,
    isLoadingForgot,
    email,
    forgotPassword,
    handleGotoLogin,
    bannerMessage,
    bannerMessageIsError,
    container
}: LoginModalProps) {
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        setDisabled(email.length < 5 || !email.includes("@"))
    }, [email]);



    return (
        <ResponsiveDialog.Content
            container={container}
            className="text-textcolor isolate m-auto my-0 max-w-[420px] border-none p-0 z-[99999]">
            <div className="w-[420px] text-center p-[15px_0] rounded-[18px] bg-background">
                <ResponsiveDialog.Title
                    className="p-0"
                >
                    <div className="flex flex-col gap-6 pb-2 pt-6">
                        <img
                            src={'/assets/Logo-Atarim-Login.svg'}
                            className="mb-1 inline-flex w-[150px] mx-auto max-w-full h-auto"
                            alt="Logo"
                        />
                        <span className="flex flex-col gap-1">
                            <h1 className="text-textcolor text-2xl font-bold">
                                Forgot Your Password?
                            </h1>
                            <p className="font-base flex justify-center self-center text-balance text-base text-[#71717a]">
                                Let's get you back in
                            </p>
                        </span>
                    </div>
                </ResponsiveDialog.Title>
                <div className="flex flex-col gap-6 p-4">
                    {bannerMessage && <div className={cn("", { error: bannerMessageIsError })}>
                        {bannerMessage}
                    </div>}
                    <div className="flex flex-col gap-2">
                        <Label htmlFor="email" className="flex items-start">
                            Email Address
                        </Label>
                        <Input
                            value={email}
                            type="email"
                            placeholder="Your Work Email Address"
                            onChange={handleChangeLoginEmail}
                        />
                    </div>
                    <Button
                        disabled={disabled || isLoadingForgot}
                        size="sm"
                        className="w-full text-sm"
                        rightIcon={<MoveRight size={18} />}
                        onClick={forgotPassword}
                        loading={isLoadingForgot}
                    >
                        Forgot Password
                    </Button>
                    <div className="my-2">
                        <Button
                            variant="ghost"
                            size="sm"
                            leftIcon={<ArrowLeft size={18} />}
                            onClick={handleGotoLogin}
                        >
                            Back to Login
                        </Button>
                    </div>
                </div>
            </div>
        </ResponsiveDialog.Content>
    );
}